export const TEST_ID = {
  ErrorContainer: 'App-Error-container',
  SummaryContainer: 'App-Error-Summary-container',
  DataContainer: 'App-Error-Data-container',
};

export const DEFAULT_MESSAGES = {
  error: 'An unknown error occurred.',
};
